import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.number.constructor.js";
export var applications = function applications(state) {
  return state.applications;
};
export var getApplicationByRef = function getApplicationByRef(state) {
  return function (ref) {
    return state.applications.find(function (a) {
      return a.get('ref_number') === Number(ref);
    });
  };
};